"use strict";

var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _moment = _interopRequireDefault(require("moment"));
var _numeral = _interopRequireDefault(require("numeral"));
var qwest = _interopRequireWildcard(require("qwest"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* globals app */

window.app = window.app || {};
var callbacks = {},
  listeners = {};
var global_listeners = {};
app.form_index = 0;
app.images_id = 0;
app.collapse_id = 0;
app.gmap_id = 0;
var initial_load = true;
_numeral.default.locale('en');
_moment.default.locale('fr');
window.numeral = _numeral.default;
window.moment = _moment.default;
window.qwest = qwest;
app.redirectIfNeeded = function (pathname) {
  if (pathname) {
    app.navigateTo(pathname, true);
    return true;
  }
};
app.navigateTo = function (path) {
  let auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!app.router_history) return;
  if (auto !== true) {
    app.state.form_error = undefined;
  }
  app.resetFunctions();
  app.router_history.push(path);
};
app.resetFunctions = function () {
  if (initial_load === true) {
    initial_load = false;
  } else {
    callbacks = {};
    listeners = {};
  }
  if (typeof ga === 'function') {
    window.ga('send', 'pageview');
  }
};
app.hasListener = function (event) {
  return listeners[event] && listeners[event].length > 0;
};
app.call = function (props) {
  if (props.event) {
    if (!listeners[props.event]) {
      console.error('listener on ' + props.event + ' does not exists');
    } else {
      listeners[props.event].filter(function (listener, index) {
        return typeof listener === 'function';
      }).forEach(function (listener, index) {
        listener(props.cb_props);
      });
    }
  } else {
    if (!callbacks[props.name]) {
      console.error('function ' + props.name + ' does not exists');
    } else {
      callbacks[props.name].filter(function (callback, index) {
        return typeof callback === 'function';
      }).forEach(function (callback, index) {
        callback(props.cb_props);
      });
    }
  }
};
app.emit = function (_ref) {
  let {
    event,
    source,
    data
  } = _ref;
  (listeners[event] || []).filter(function (listener, index) {
    return typeof listener === 'function';
  }).forEach(function (listener, index) {
    listener({
      data: data,
      source: source
    });
  });
  (global_listeners[event] || []).filter(function (listener, index) {
    return typeof listener === 'function';
  }).forEach(function (listener, index) {
    listener({
      data: data,
      source: source
    });
  });
};
app.push = function (_ref2) {
  let {
    event,
    cb,
    global
  } = _ref2;
  if (event && global === true) {
    global_listeners[event] = global_listeners[event] || [];
    global_listeners[event].push(cb);
  } else if (event) {
    if (event === 'documentScroll' && !app.hasListener(event)) {
      handleDocumentScrollListener('append');
    }
    listeners[event] = listeners[event] || [];
    listeners[event].push(cb);
  } else {
    callbacks[name] = callbacks[name] || [];
    callbacks[name].push(cb);
  }
};
function handleDocumentScrollListener(option) {
  var scroll_area = document.querySelector('.page-content');
  if (!scroll_area) return console.error('no scroll area');
  var ticking = false;
  if (option === 'append') {
    scroll_area.addEventListener('scroll', listener);
  } else if (option === 'remove') {
    scroll_area.removeEventListener('scroll', listener);
  }
  function listener(e) {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        ticking = false;
        app.call({
          event: 'documentScroll'
        });
      });
    }
    ticking = true;
  }
}
app.delete = function (_ref3) {
  let {
    event,
    cb,
    name
  } = _ref3;
  if (event && listeners[event]) {
    listeners[event] = listeners[event].filter(function (listener, index) {
      return cb !== listener;
    });
  } else if (callbacks[name]) {
    callbacks[name] = callbacks[name].filter(function (callback, index) {
      return cb !== callback;
    });
  }
};
app.state = app.state || {};
app.initState = function () {
  app.History = window.History;
  app.state = app.state || {};
  global_listeners = {};
  (0, _assign2.default)(app.state, {
    session: {},
    search_data: {},
    recaptchas: {}
  });
  if (getIEVersion() > 0) {
    app.state.ie = getIEVersion();
  }
  function getIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0) {
      return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
    }

    // If IE 11 then look for Updated user agent string.
    else if (navigator.userAgent.match(/Trident\/7\./)) {
      return 11;
    } else {
      return 0;
    }
  }
};
app.initState();
